import { siteData } from "../data/mock";
import { Instagram, MessageCircle } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#1F1F1F' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="mb-3">
              <span className="text-lg font-bold text-white block">
                Dra. Giovana Gamborgi
              </span>
              <span className="text-xs font-semibold tracking-[0.15em] uppercase" style={{ color: '#85BCFF' }}>
                {siteData.brand.tagline}
              </span>
            </div>
            <p className="text-sm text-slate-400 mt-3">
              {siteData.contact.address.city}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">
              Navegação
            </h4>
            <nav className="flex flex-col gap-2.5">
              {["Início", "Sobre", "Especialidades", "Invisalign", "Contato"].map(
                (item) => (
                  <a
                    key={item}
                    href={`#${item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                  >
                    {item}
                  </a>
                )
              )}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">
              Fale Conosco
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href={siteData.brand.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm transition-colors hover:text-white"
                style={{ color: '#85BCFF' }}
              >
                <MessageCircle size={15} />
                WhatsApp
              </a>
              <a
                href={siteData.brand.instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm transition-colors hover:text-white"
                style={{ color: '#85BCFF' }}
              >
                <Instagram size={15} />
                @giovana_gamborgi
              </a>
            </div>
          </div>
        </div>

        {/* Divider + Copyright */}
        <div className="mt-10 pt-6 border-t border-slate-800">
          <p className="text-xs text-center text-slate-500">
            © {currentYear} Dra. Giovana Gamborgi — Odontologia que transforma. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
